import React from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated } from "../utils/auth"; // Ruta correcta depenent d'on posis el fitxer auth.js

const Privateroute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/login" />;
};

export default Privateroute;
